export const careCreditInterestTypes = {
  FIXED: 'fixed',
  DEFERRED: 'deferred'
};
